const getHash = () =>
    Date.now().toString(36) + Math.random().toString(36).substring(2)
const state = {
    items: [],
    secondary_items: [],
    arranged_items: [],
    itemsChanged: false,
    orderChanged: false,
}

const getOrderPricing = items => {
    return items.reduce(
        (_pricing, item) => {
            if (!item.deleted) {
                let itemCost =
                    (parseFloat(item.price) || 0) *
                    (parseFloat(item.quantity) || 0)
                _pricing.total += itemCost
                _pricing.tax +=
                    (itemCost * (parseFloat(item.tax_rate) || 0)) / 100
            }
            return _pricing
        },
        { tax: 0, total: 0 }
    )
}

const getItems = (items, types, is_discount) => {
    return items.filter(x => {
        const itemType = types.find(y => y.id == x.order_item_type_id)
        if (is_discount) {
            return !x.deleted && !!itemType.is_discount
        } else {
            return !x.deleted && !itemType.is_discount
        }
    })
}

const getAdjustmentTotals = adjustmentItems => {
    const defaultTitle = 'Discount'
    let title = defaultTitle
    let description = defaultTitle
    return adjustmentItems.reduce(
        (_pricing, item, idx) => {
            if (!item.deleted) {
                let itemCost =
                    (parseFloat(item.price) || 0) *
                    (parseFloat(item.quantity) || 0)

                _pricing.total += itemCost
                _pricing.tax +=
                    (itemCost * (parseFloat(item.tax_rate) || 0)) / 100
                if (idx == 0) {
                    _pricing.title = item.name
                    _pricing.description = item.description
                } else {
                    _pricing.title = defaultTitle
                    _pricing.description = defaultTitle
                }
            }
            return _pricing
        },
        { tax: 0, total: 0, title, description }
    )
}

const getters = {
    orderPricing(state) {
        return getOrderPricing(state.items)
    },

    itemsTotals(state, getters, rootState) {
        const types = rootState.itemType.items
        const primary_totals = getOrderPricing(getters['itemsOnly'])
        const secondaryItemsOnly = getItems(state.secondary_items, types, false)
        const secondary_totals = getOrderPricing(secondaryItemsOnly)
        return {
            tax: primary_totals.tax + secondary_totals.tax,
            total: primary_totals.total + secondary_totals.total,
        }
    },

    adjustmentTotals(state, getters, rootState) {
        const types = rootState.itemType.items
        const { tax, total, title, description } = getAdjustmentTotals(
            getters['adjustmentItems']
        )
        const secItemsOnly = getItems(state.secondary_items, types, true)
        const secAdjustTotals = getAdjustmentTotals(secItemsOnly)
        return {
            tax: tax + secAdjustTotals.tax,
            total: total + secAdjustTotals.total,
            title,
            description,
        }
    },

    itemsOnly(state, getters, rootState) {
        const types = rootState.itemType.items
        return getItems(state.items, types, false)
    },

    adjustmentItems(state, getters, rootState) {
        const types = rootState.itemType.items
        return getItems(state.items, types, true)
    },

    hasPricing(state) {
        return !!state.items.length
    },
    orderTotal(state) {
        return getOrderPricing(state.items)
    },

    orderTax(state) {
        return getOrderPricing(state.items)
    },
}

const mutations = {
    SET_ITEMS(state, items) {
        state.items = items
    },
    SET_SECONDARY_ITEMS(state, items) {
        state.secondary_items = items
    },
    SET_CHANGED(state, x) {
        state.itemsChanged = x
    },
    SET_ORDER_CHANGED(state, x) {
        state.orderChanged = x
    },
    ARRANGED_DATA(state, arranged_items) {
        state.arranged_items = arranged_items
    },
}

const actions = {
    load({ commit }, initialItems) {
        console.log('initialItems', initialItems)
        const items = initialItems.map(x => {
            x.hash = x.hash || getHash()
            return x
        })
        commit('SET_ITEMS', items)
        commit('SET_CHANGED', false)
    },

    clear({ commit }) {
        commit('SET_ITEMS', [])
        commit('SET_CHANGED', false)
    },

    merge({ state, commit }, item) {
        item.hash = item.hash || getHash()
        const items = [...state.items]
        let index = items.findIndex(
            x => x.hash == item.hash || x.master_item_id == item.master_item_id
        )
        if (index >= 0) items.splice(index, 1, item)
        else items.push(item)
        commit('SET_CHANGED', true)
        commit('SET_ITEMS', items)
    },

    delete({ state, commit }, hash) {
        const items = [...state.items]
        const index = items.findIndex(x => x.hash == hash)
        items.splice(index, 1)
        commit('SET_CHANGED', true)
        commit('SET_ITEMS', items)
    },
    deleteTemplate({commit}) {
        commit('SET_ITEMS', [])
    },
    async arrange(context, payload) {
        console.log('payLoad', payload)
        context.commit('SET_ORDER_CHANGED', true)
        context.commit('ARRANGED_DATA', payload)
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
